// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ko-0";
export var leftAlign = "_ko-4";
export var listItem = "_ko-2";
export var listItemWrapper = "_ko-1";
export var operationText = "_ko-3";